import warningGeneral from "../assets/warningGeneral.png";
import { Modal } from "@mui/material";
import PropTypes from "prop-types";
import Button from "./Button";
import React from "react";

const ErrorModal = ({ open, title, message, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex justify-center">
          <img src={warningGeneral} alt="error icon" width="60px" />
        </div>
        <p className="text-center text-xl font-semibold mb-4">{title}</p>
        <p className="text-[#60656D] text-center mb-4">{message}</p>
        <Button className="w-full text-white" onClick={onClose}>
          Ok
        </Button>
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  message: PropTypes.string,
  title: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

export default ErrorModal;
